import { render } from "./ExpertStatistics.vue?vue&type=template&id=73664bd2"
import script from "./ExpertStatistics.vue?vue&type=script&lang=js"
export * from "./ExpertStatistics.vue?vue&type=script&lang=js"

import "./ExpertStatistics.vue?vue&type=style&index=0&id=73664bd2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__